import { useLocation } from "react-router-dom";
import { useState } from "react";
import "./checkout.css";
import termsPdf from "../../assets/T&C.pdf";
import Swal from "sweetalert2";
import axios from "axios";
import { API_BASE } from "../../App";

export default function Checkout() {
  const location = useLocation();
  const trainingId = location.state?.trainingId || "0ec3f301-7960-4d29-bcf1-81ca4bfdfaae";

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    address: "",
    zipCode: "",
    country: "",
    phone: "",
    description: "",
    amount: ""
  });
  const [showOtherJob, setShowOtherJob] = useState(false);
  const [agreeTC, setAgreeTC] = useState(false);
  const [coupon, setCoupon] = useState("FIRST10");
  const [discount, setDiscount] = useState(0);
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [couponError, setCouponError] = useState("");
  const [loading, setLoading] = useState(false)

  const applyCoupon = async () => {
    try {
      const payload = {
        couponCode: coupon, trainingId
      }

      const res = await axios.post(`${API_BASE}/coupons/validate`, payload);
      if (res.data.valid) {
        const discountAmount = Math.round(formData.amount * (res.discount_percent / 100));

        setDiscount(discountAmount);
        setIsCouponApplied(true);
        setCouponError("");
      }
    } catch (err) {
      setDiscount(0);
      setIsCouponApplied(false);
      setCouponError("Invalid or expired coupon");
      throw new Error(
        err.response?.data?.message || "Invalid or expired coupon"
      );
    }
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    if (!formData.amount || Number(formData.amount) <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Amount",
        text: "Please enter a valid amount before submitting.",
        confirmButtonColor: "#2563eb",
      });
    }

    
    try {
      const payload = {
        trainingId,
        couponCode: coupon,
        firstName: formData?.firstName,
        lastName: formData?.lastName,
        email: formData?.email,
        phone: formData?.phone,
        address: formData?.address,
        zipCode: formData?.zipCode,
        country: formData?.country,
        description: formData?.description,
        amount:formData?.amount
      }
      const {data} = await axios.post(`${API_BASE}/checkout`, payload);
      console.log(data,"data")
      if (data) {
        const options = {
          key: data.razorpay_key,
          amount: data.amount,
          currency: "INR",
          order_id: data.order_id,
          name: "Company Trainings",
          description: "Course Payment",
          handler: () => {
            alert("Payment processing... Confirmation via webhook");
          },
          modal: {
            ondismiss: function () {
              setLoading(false);
            }
          }
        };
        console.log(options)
        const rzp = new window.Razorpay(options);
        console.log(rzp, "r")
        rzp.open();
      }

    } catch (error) {
      console.log(error.message)
      setLoading(false)
    } finally {
      setLoading(false)
    }
  };

  return (
    <div className="checkout-page">
      <form className="checkout-form" onSubmit={handleSubmit}>
        {/* LEFT : BILLING DETAILS */}
        <div className="checkout-card">
          <h2 className="card-title">Billing Details</h2>

          <div className="checkout-row">
            <input name="firstName" placeholder="First Name" required onChange={handleChange} value={formData.firstName} />
            <input name="lastName" placeholder="Last Name" required onChange={handleChange} value={formData.lastName} />
          </div>
          <div className="checkoutRows">
            <input onChange={handleChange} name="email" value={formData.email} type="email" placeholder="Enter Email" />
          </div>
          <div className="checkoutRows">
            <input onChange={handleChange} name="address" value={formData.address} type="text" placeholder="Enter Street,City & State" required />
          </div>


          <div className="checkout-row">
            <input onChange={handleChange} name="zipCode" value={formData.zipCode} type="Number" placeholder="Zip code" required />
            <input onChange={handleChange} name="country" value={formData.country} type="text" placeholder="Country" required />
          </div>
          <div className="checkoutRows">
            <input onChange={handleChange} name="phone" value={formData.phone} type="Number" placeholder="Phone" required />
          </div>
          <div className="checkoutRows">
            <textarea onChange={handleChange} name="description" value={formData.description} type="Number" placeholder="Description" required ></textarea>
          </div>

          <p className="privacy-text">
            Your information is protected and used solely for billing and communication purposes.
          </p>

          {/* TERMS */}
          <div className="terms-box">
            <label className="terms-label">
              <input
                type="checkbox"
                checked={agreeTC}
                onChange={(e) => setAgreeTC(e.target.checked)}
                required
              />
              <span>
                I agree to the{" "}
                <a href={termsPdf} target="_blank" rel="noopener noreferrer">
                  Terms & Conditions
                </a>
              </span>
            </label>
          </div>
        </div>

        {/* RIGHT : SUMMARY */}
        <div className="checkout-summary">
          <h2 className="card-title">Order Summary</h2>

          <div className="summary-row">
            <span>Pricing</span>
            <span className="price-hidden">To be confirmed</span>
          </div>

          <p className="price-note">
            Final pricing will be shared by our team after reviewing your details and eligibility.
          </p>

          <div className="coupon-container">
            <div className="coupon-input-row">
              <input
                type="text"
                value={coupon}
                onChange={(e) => setCoupon(e.target.value.toUpperCase())}
                placeholder="Enter Coupon Code"
                className="coupon-input"
              />
              <button
                type="button"
                onClick={applyCoupon}
                className="coupon-button"
              >
                Apply
              </button>
            </div>

            {couponError && (
              <p className="coupon-error">{couponError}</p>
            )}

            {isCouponApplied && (
              <p className="coupon-success">
                Coupon applied! You saved ₹{discount}
              </p>
            )}
          </div>


          <div className="summary-row">
            <span>Enter Amount</span>
          </div>

          <input
            type="number"
            name="amount"
            className="amount-input"
            placeholder="Enter amount (₹)"
            value={formData.amount}
            onChange={handleChange}
            required
          />

          <div className="payment-box">
            <p className="payment-title">Next Step</p>
            <div className="payment-option active">
              <span>Submit details to receive payment instructions</span>
            </div>
          </div>

          <button className="pay-btn" type="submit" disabled={!agreeTC}>
            Submit & Continue
          </button>

          <p className="secure-text">
            🔒 Verified & Secure · Our team will contact you shortly
          </p>
        </div>
      </form>
    </div>
  );
}